<template>
  <v-card class="elevation-0 pa-4 h-100 summary-card">
    <v-card-title class="text-h6 mb-2 font-weight-bold">Buy</v-card-title>
    <v-table density="compact" class="custom-table">
      <thead>
        <tr>
          <th class="left-header"> </th>
          <th class="top-header">New Buy</th>
          <th class="top-header">Avg Buy</th>
          <th class="top-header">Total Buy</th>
        </tr>
      </thead>
      <tbody v-if="platformSummary">
        <tr>
          <td class="left-header">Current Month</td>
          <td>{{ $helper.formatPrice(currentMonth.new_buy) }}</td>
          <td>{{ $helper.formatPrice(currentMonth.avg_buy) }}</td>
          <td>{{ $helper.formatPrice(currentMonth.buy) }}</td>
        </tr>
        <tr>
          <td class="left-header">Previous Month</td>
          <td>{{ $helper.formatPrice(previousMonth.new_buy) }}</td>
          <td>{{ $helper.formatPrice(previousMonth.avg_buy) }}</td>
          <td>{{ $helper.formatPrice(previousMonth.buy) }}</td>
        </tr>
        <tr>
          <td class="left-header">Quarter</td>
          <td>{{ $helper.formatPrice(quarter.new_buy) }}</td>
          <td>{{ $helper.formatPrice(quarter.avg_buy) }}</td>
          <td>{{ $helper.formatPrice(quarter.buy) }}</td>
        </tr>
        <tr>
          <td class="left-header">Current Year</td>
          <td>{{ $helper.formatPrice(currentYear.new_buy) }}</td>
          <td>{{ $helper.formatPrice(currentYear.avg_buy) }}</td>
          <td>{{ $helper.formatPrice(currentYear.buy) }}</td>
        </tr>
        <tr>
          <td class="left-header">Current Financial Year</td>
          <td>{{ $helper.formatPrice(currentFinancialYear.new_buy) }}</td>
          <td>{{ $helper.formatPrice(currentFinancialYear.avg_buy) }}</td>
          <td>{{ $helper.formatPrice(currentFinancialYear.buy) }}</td>
        </tr>
        <tr>
          <td class="left-header font-weight-bold text-primary">Total</td>
          <td class="font-weight-bold">{{ $helper.formatPrice(platformSummary.new_buy) }}</td>
          <td class="font-weight-bold">{{ $helper.formatPrice(platformSummary.avg_buy) }}</td>
          <td class="font-weight-bold">{{ $helper.formatPrice(platformSummary.buy) }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr v-for="i in 6" :key="i">
          <td colspan="4">
            <v-skeleton-loader type="table-row" />
          </td>
        </tr>
      </tbody>
    </v-table>
  </v-card>
</template>

<style scoped>
.summary-card {
  background: #fff !important;
  border: 1px solid var(--border);
  border-radius: 12px;
}

.summary-card :deep(.v-card-title) {
  color: var(--dark);
  font-size: 1.05rem;
  padding: 0;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.custom-table th,
.custom-table td {
  padding: 9px 10px;
  text-align: left;
}

.custom-table th {
  font-weight: 600;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border);
}

.custom-table td {
  color: var(--dark);
  border-bottom: 1px solid #f1f2f4;
}

.left-header {
  color: var(--text-muted);
  font-weight: 500;
  white-space: nowrap;
}

.custom-table tr:last-child td {
  border-bottom: none;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.custom-table tr:last-child .left-header {
  color: var(--primary);
}
</style>

<script>

import { storeToRefs } from 'pinia';
import { useAlertStore, platformStore } from '@/stores';
import moment from 'moment'

import gql from 'graphql-tag';

const PLATFORMS_OPTION_QUERY = gql`
  query platformSummary($platformIds: [ID]) {
    platformSummary(platform_ids: $platformIds) {
      buy
      new_buy
      avg_buy
    }
  }
`;

const PLATFORMS_OPTION_DATE_WISE_QUERY = gql`
  query StockTransactionsPlatformAndDateWise($platformIds: [ID], $fromDate: String, $toDate: String) {
    stockTransactionsPlatformAndDateWise(platform_ids: $platformIds, fromDate: $fromDate, toDate: $toDate) {
      buy
      new_buy
      avg_buy
    }
  }
`;

export default {
  name: 'Buy-Box-List',
  data() {
    const today = new Date(new Date().toLocaleString(undefined, {timeZone: 'Asia/Kolkata'}));
    const currentYear = moment().year();
    const firstDayOFCurrentMonth = moment().startOf('month').format('YYYY-MM-DD');
    const lastDayOFCurrentMonth = moment().endOf('month').format('YYYY-MM-DD');

    const firstDayOFPreviousMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    const lastDayOFPreviousMonth  = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');

    //const quarter = Math.floor((today.getMonth() / 3));
    const startFullQuarter = moment().startOf('quarter').format('YYYY-MM-DD');
    const endFullQuarter = moment().endOf('quarter').format('YYYY-MM-DD');

    const PreYear = Math.floor(today.getMonth() / 3 + 1) > 1 ? moment().startOf('quarter').format('YYYY') : Number(moment().startOf('quarter').format('YYYY')) - 1;
    const NextYear = Math.floor(today.getMonth() / 3 + 1) > 1 ? Number(moment().startOf('quarter').format('YYYY')) + 1 : moment().startOf('quarter').format('YYYY');
  
    return {
      currentMonth: [],
      previousMonth: [],
      quarter: [],
      currentYear: [],
      currentFinancialYear: [],
      total: [],
      date: {
        currentMonth : {'from': firstDayOFCurrentMonth, 'to': lastDayOFCurrentMonth},
        previousMonth : {'from': firstDayOFPreviousMonth, 'to': lastDayOFPreviousMonth},
        quarter : {'from': startFullQuarter, 'to': endFullQuarter },
        currentYear : {'from': currentYear+"-01-01", 'to': currentYear+"-12-31"},
        currentFinancialYear : {'from': PreYear+"-04-01", 'to': NextYear+"-03-31"},
      }
    }
  },
  setup() {
    const alertStore = platformStore();
    const { platform } = storeToRefs(alertStore);
    return { 
      alertStore$: useAlertStore(),
      platformOptions: platform,
    };
  },
  methods: {
    getDateWiseData() {
      /** currentMonth **/

      this.$apollo.query({
          query: PLATFORMS_OPTION_DATE_WISE_QUERY,
          variables: {
              "platformIds": JSON.parse(this.platformOptions),
              "fromDate": this.date.currentMonth.from,
              "toDate"  : this.date.currentMonth.to
          },
      }).then((response) => {
          this.currentMonth = response.data.stockTransactionsPlatformAndDateWise;
      }).catch((error) => {
          this.alertStore$.error(JSON.stringify(error.message));
      });

      /*** previousMonth **/

      this.$apollo.query({
          query: PLATFORMS_OPTION_DATE_WISE_QUERY,
          variables: {
              "platformIds": JSON.parse(this.platformOptions),
              "fromDate": this.date.previousMonth.from,
              "toDate"  : this.date.previousMonth.to
          },
      }).then((response) => {
          this.previousMonth = response.data.stockTransactionsPlatformAndDateWise;
      }).catch((error) => {
          this.alertStore$.error(JSON.stringify(error.message));
      });

      /** quarter **/

      this.$apollo.query({
          query: PLATFORMS_OPTION_DATE_WISE_QUERY,
          variables: {
              "platformIds": JSON.parse(this.platformOptions),
              "fromDate": this.date.quarter.from,
              "toDate"  : this.date.quarter.to
          },
      }).then((response) => {
          this.quarter = response.data.stockTransactionsPlatformAndDateWise;
      }).catch((error) => {
          this.alertStore$.error(JSON.stringify(error.message));
      });

      /** currentYear **/

      this.$apollo.query({
          query: PLATFORMS_OPTION_DATE_WISE_QUERY,
          variables: {
              "platformIds": JSON.parse(this.platformOptions),
              "fromDate": this.date.currentYear.from,
              "toDate"  : this.date.currentYear.to
          },
      }).then((response) => {
          this.currentYear = response.data.stockTransactionsPlatformAndDateWise;
      }).catch((error) => {
          this.alertStore$.error(JSON.stringify(error.message));
      });

      /** currentYear **/

      this.$apollo.query({
          query: PLATFORMS_OPTION_DATE_WISE_QUERY,
          variables: {
              "platformIds": JSON.parse(this.platformOptions),
              "fromDate": this.date.currentFinancialYear.from,
              "toDate"  : this.date.currentFinancialYear.to
          },
      }).then((response) => {
          this.currentFinancialYear = response.data.stockTransactionsPlatformAndDateWise;
      }).catch((error) => {
          this.alertStore$.error(JSON.stringify(error.message));
      });

    },

    calculateProfitLossPercentage(sell, netSell){
      return (netSell / (sell - netSell));
    }
  },
  watch:{
     'platformSummary': function (){
      this.getDateWiseData();    
     },
  },
  mounted(){
    this.getDateWiseData();
  },
  apollo: {
    platformSummary: {
      query: PLATFORMS_OPTION_QUERY,
      variables () {
        return {
          platformIds: JSON.parse(this.platformOptions)
        }
      },
      error(error){
        this.alertStore$.error(JSON.stringify(error.message));
      }
    },
  }
}
</script>